import type { FC } from 'react'
import { useState, useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextInput from '@/components/input/TextInput'
import ctx from '@/context/AppContext'
import { useAddLandlordRefereeMutation } from '@/lib/apollo'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

interface Props {
  customerId: string
  subjectId: string
  onClose: () => void
}

const AddLandlordReferenceSidebar: FC<Props> = ({ customerId, subjectId, onClose }) => {
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [phone, setPhone] = useState<string>('')

  const { personId } = useContext(ctx)

  const [handleAddLandlordReferee, { data, loading, error }] =
    useAddLandlordRefereeMutation()

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<h1>Add landlord referee</h1>}
      content={
        data ? (
          <>This landlord referee has been added.</>
        ) : (
          <>
            <p>
              Please provide the details of the landlord referee you would like to add.
            </p>
            <TextInput
              type="text"
              label="Name"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setName(e.target.value)
              }}
              value={name}
            />
            <TextInput
              type="text"
              label="Email"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value)
              }}
              value={email}
            />
            <TextInput
              type="text"
              label="Phone"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPhone(e.target.value)
              }}
              value={phone}
            />
          </>
        )
      }
      footer={
        <>
          {error?.message && <ErrorContainer>{error?.message}</ErrorContainer>}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!data && (
              <Button
                disabled={loading || name === '' || email === '' || phone === ''}
                onClick={() =>
                  handleAddLandlordReferee({
                    variables: {
                      customerId,
                      subjectId,
                      userId: personId ?? '',
                      email,
                      name,
                      phone,
                    },
                  })
                }
              >
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default AddLandlordReferenceSidebar
